var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("vat-declaration-result")))]),
      _c("table", [
        _c("tr", { staticClass: "header" }, [
          _c("th", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("II"))),
          ]),
          _c("th", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("III"))),
          ]),
          _c("th", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("IV"))),
          ]),
          _c("th", { attrs: { colspan: "2" } }, [_vm._v(_vm._s(_vm.$ct("V")))]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(0)))]),
          _c("td", [_vm._v("00")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(81)))]),
          _c("td", [_vm._v("81")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(54)))]),
          _c("td", [_vm._v("54")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(59)))]),
          _c("td", [_vm._v("59")]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(1)))]),
          _c("td", [_vm._v("01")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(82)))]),
          _c("td", [_vm._v("82")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(55)))]),
          _c("td", [_vm._v("55")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(62)))]),
          _c("td", [_vm._v("62")]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(2)))]),
          _c("td", [_vm._v("02")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(83)))]),
          _c("td", [_vm._v("83")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(56)))]),
          _c("td", [_vm._v("56")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(64)))]),
          _c("td", [_vm._v("64")]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(3)))]),
          _c("td", [_vm._v("03")]),
          _c("td"),
          _c("td"),
          _c("td", [_vm._v(_vm._s(_vm.getValue(57)))]),
          _c("td", [_vm._v("57")]),
          _c("td"),
          _c("td", [_vm._v("66")]),
        ]),
        _c("tr", [
          _c("td", { attrs: { colspan: "8" } }, [
            _c("div", { staticClass: "grower" }),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(44)))]),
          _c("td", [_vm._v("44")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(84)))]),
          _c("td", [_vm._v("84")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(61)))]),
          _c("td", [_vm._v("61")]),
          _c("th", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("VI"))),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(45)))]),
          _c("td", [_vm._v("45")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(85)))]),
          _c("td", [_vm._v("85")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(63)))]),
          _c("td", [_vm._v("63")]),
          _c("td", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.getValue(71)))]),
          _c("td", [_vm._v("71")]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(46)))]),
          _c("td", [_vm._v("46")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(86)))]),
          _c("td", [_vm._v("86")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(65)))]),
          _c("td", [_vm._v("65")]),
          _c("td", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.getValue(72)))]),
          _c("td", [_vm._v("72")]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(47)))]),
          _c("td", [_vm._v("47")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(87)))]),
          _c("td", [_vm._v("87")]),
          _c("td"),
          _c("td"),
          _c("td"),
          _c("td"),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(48)))]),
          _c("td", [_vm._v("48")]),
          _c("td", [_vm._v(_vm._s(_vm.getValue(88)))]),
          _c("td", [_vm._v("88")]),
          _c("td"),
          _c("td"),
          _c("th", { attrs: { colspan: "2" } }, [
            _vm._v(_vm._s(_vm.$ct("VII"))),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.getValue(49)))]),
          _c("td", [_vm._v("49")]),
          _c("td"),
          _c("td"),
          _c("td"),
          _c("td"),
          _c("td", [_vm._v(_vm._s(_vm.getValue(91)))]),
          _c("td", [_vm._v("91")]),
        ]),
      ]),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.close")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "mr",
              attrs: { disabled: _vm.downloading, icon: "paper-plane" },
              on: {
                click: function ($event) {
                  return _vm.send()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("send")))]
          ),
          _c(
            "w-button",
            {
              staticClass: "mr",
              attrs: { disabled: _vm.downloading, icon: "file-pdf" },
              on: {
                click: function ($event) {
                  return _vm.downloadPdf()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.download-pdf")))]
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.downloading, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.download()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.download-xml")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.sendModal } },
        [
          _vm.sendModal && _vm.xmlFile && _vm.pdfFile
            ? _c("app-send-message-dialog", {
                attrs: {
                  attachements: [_vm.xmlFile, _vm.pdfFile],
                  "is-html": "",
                },
                on: {
                  sent: function ($event) {
                    _vm.sendModal = false
                  },
                  close: function ($event) {
                    _vm.sendModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }